/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Alert } from 'reactstrap';
import classNames from 'classnames';

const Input = ({
  register,
  name,
  type,
  rules = {},
  error,
  disabled,
  readonly,
  loading,
  style,
  inline,
  defaultValue
  // onChange = null,
  // onBlur = null
}) => (
  <div className="input-container" style={inline && { display: 'inline' }}>
    <input
      type={type || 'text'}
      {...register(name, rules)}
      defaultValue={defaultValue}
      // onChange={onChange}
      // onBlur={onBlur}
      className={classNames('form-control', { 'is-invalid': !!error })}
      disabled={disabled}
      readOnly={readonly}
      style={style}
    />

    {loading && (
      <div className="icon-container">
        <i className="loader" />
      </div>
    )}
    {error && typeof error === 'string' && <Alert color="danger">{error}</Alert>}
  </div>
);
export default Input;

export const Select = ({
  register,
  name,
  rules = {},
  error,
  disabled,
  readonly,
  loading,
  children
}) => (
  <div className="input-container">
    <select
      {...register(name, rules)}
      className={classNames('form-control', { 'is-invalid': !!error })}
      disabled={disabled}
      readOnly={readonly}
    >
      {children}
    </select>

    {loading && (
      <div className="icon-container">
        <i className="loader" />
      </div>
    )}
    {error && typeof error === 'string' && <Alert color="danger">{error}</Alert>}
  </div>
);

export const TextArea = ({ register, name, rules = {}, error, disabled, readonly, loading }) => (
  <div className="input-container">
    <textarea
      {...register(name, rules)}
      className={classNames('form-control', { 'is-invalid': !!error })}
      rows={10}
      disabled={disabled}
      readOnly={readonly}
    />

    {loading && (
      <div className="icon-container">
        <i className="loader" />
      </div>
    )}
    {error && typeof error === 'string' && <Alert color="danger">{error}</Alert>}
  </div>
);
